import React, { Component, PropTypes } from 'react';
import { get } from 'lodash';
import Status from './StatusComponent';
import { GoogleAds } from '../../../../constants/ManageApps';
import StatusMessage from './StatusMessageComponent';

class GoogleAdsSection extends Component {
    render() {
        const status = get(this.props.configurationObject, 'status');
        const chainStatus = get(this.props.chainConfigurationObject, 'status');

        return (
            <section className="content-section">
                <Status
                    objectName="googleAds"
                    value={status}
                    level={this.props.level}
                    parentValue={chainStatus}
                    setValue={(key, value) => {
                        this.props.setValue(key, value);
                    }}
                />
                <StatusMessage appName={GoogleAds.appName} value={status} parentValue={chainStatus} />
            </section>
        );
    }
}

GoogleAdsSection.propTypes = {
    configurationObject: PropTypes.obj,
    chainConfigurationObject: PropTypes.obj,
    level: PropTypes.string,
    setValue: PropTypes.func
};

export default GoogleAdsSection;



// WEBPACK FOOTER //
// ./src/components/pages/manage/apps/GoogleAdsSection.js